import { render, staticRenderFns } from "./PromocoesHome.vue?vue&type=template&id=7306ea00"
import script from "./PromocoesHome.vue?vue&type=script&lang=js"
export * from "./PromocoesHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports